import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Anchor,
  Button,
  Checkbox,
  Paper,
  PasswordInput,
  TextInput,
} from '@mantine/core';
import { useTranslation } from 'react-i18next';
import CustomSnackbar from '../components/CustomSnackbar';
import classes from './LoginLogout.module.css';
import { useAuth } from "../contexts/AuthProvider";

const LoginPage: React.FC = () => {
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [rememberMe, setRememberMe] = useState<boolean>(false);
  const [errorMsg, setErrorMsg] = useState<string>('');
  const navigate = useNavigate();
  const { login } = useAuth();
  const { t } = useTranslation();

  const handleLogin= async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setErrorMsg('');

    try {
      await login(email, password, rememberMe);
      navigate('/');
    } catch {
      setErrorMsg(t('auth.login.invalidCredentials'));
    }
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.leftContainer} style={{ position: 'relative' }}>
        <Paper component="form" onSubmit={handleLogin} className={classes.form} radius={0} p={30}>
          <img src="/images/icon_h.png" alt="Logo" className={classes.logo} />
          <TextInput
            label={t('auth.login.username')}
            placeholder={t('auth.login.usernamePlaceholder')}
            size="md"
            value={email}
            onChange={(event) => setEmail(event.currentTarget.value)}
            className={classes.textInput}
            required
          />
          <PasswordInput
            label={t('auth.login.password')}
            placeholder={t('auth.login.passwordPlaceholder')}
            mt="md"
            size="md"
            value={password}
            onChange={(event) => setPassword(event.currentTarget.value)}
            className={classes.passwordInput}
            required
          />

          <div className={classes.checkboxContainer}>
            <Checkbox label={t('auth.login.rememberMe')} size="md" className={classes.customCheckbox} checked={rememberMe} onChange={(event) => setRememberMe(event.currentTarget.checked)} />
            <Anchor<'a'>
              href="#"
              fw={700}
              className={classes.customAnchor}
              onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                event.preventDefault();
                navigate('/forgot-password');
              }}
            >
              {t('auth.login.forgotPassword')}
            </Anchor>
          </div>

          <Button type="submit" fullWidth mt="xl" size="md" className={classes.customButton}>
            {t('auth.login.submit')}
          </Button>
        </Paper>
        {/* Snackbar renderizado dentro do container da esquerda */}
        <CustomSnackbar
          opened={!!errorMsg}
          message={errorMsg}
          onClose={() => setErrorMsg('')}
        />
      </div>

      <div className={classes.divider} />
      <div className={classes.rightContainer} />
    </div>
  );
};

export default LoginPage;
